export function isAdminSubdomain() {
  return window.location.hostname === "admin.yanshtechnologies.in" || window.location.hostname.startsWith("admin.");
}

export function stripAdminBase(pathname) {
  const normalized = String(pathname || "/").replace(/^\/admin(?=\/|$)/, "") || "/";
  return normalized.endsWith("/") && normalized !== "/" ? normalized.slice(0, -1) : normalized;
}

export function adminPath(path = "/") {
  const cleanPath = String(path || "/").startsWith("/") ? String(path || "/") : `/${path}`;
  const normalized = cleanPath.endsWith("/") && cleanPath !== "/" ? cleanPath.slice(0, -1) : cleanPath;

  if (isAdminSubdomain()) {
    return normalized;
  }

  return normalized === "/" ? "/admin" : `/admin${normalized}`;
}

export function isAdminEntryPath(pathname) {
  return stripAdminBase(pathname) === "/";
}
